
import React, { Component } from 'react';


const RouteNightDrivemap = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        console.log("Props ", props);
        props.onShowNightDriveRouteMap(props.data);
    };

    return (
        <div>
			<button onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-map-pins f20"></i> </button>
       
        </div>
    );
};

export default RouteNightDrivemap;
